import { Incident } from "../models/Incident";
import { map, uniqBy, forEach, reduce, filter } from 'lodash';
import { SEVERITY, IDLE_TIME_INCIDENT_NAME} from "../constants";

export interface IIncidentDetails {
	name?: string;
	events?: number;
	details?: string;
	severity?: SEVERITY;
}

// The scorecard emits placeholder records for violations it counted but whose detail
// records could not be found.  These always carry an incidentID of -1 (real incidents
// are always >= 1).  They are still counted as events on the scorecard; on the incident
// detail page their occurrence row shows a "details missing" message in place of the
// (absent) date.
const PLACEHOLDER_INCIDENT_ID = -1;

export function isPlaceholderIncident(incident?: Incident): boolean {
	return incident?.incidentID === PLACEHOLDER_INCIDENT_ID;
}

export function buildIncidents(incidents:Incident[]|undefined) : [IIncidentDetails] {
	if (incidents) {

		//Currently we are using name since Incident doesn't seem to have type or something - Arthur
		const unique  = filter(map(uniqBy(incidents, inc => inc.name), inc => {
			return {name: inc.name, severity: inc.severity, details: inc.details}
		}), inc => (inc.severity === SEVERITY.CRITICAL || inc.severity === SEVERITY.WARNING));

		forEach(unique, un => {
			un.events = reduce( filter(incidents, inc => inc.name === un.name), (sum, inc) => sum + 1, 0 )
		})

		forEach(unique, un => {
			if (un.name !== IDLE_TIME_INCIDENT_NAME) {
				un.details = `${un?.events} events`
			}
		})
		return unique
	}
	else return [] as any as [IIncidentDetails]
}